import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { premiumEvalOption } from "../../store/premiumEvalOption/actions";
export var usePremiumEvalOptionGetAll = function (trigger, description) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responsePremiumEvalOption: (_a = state.PremiumEvalOption.responsePremiumEvalOption) === null || _a === void 0 ? void 0 : _a.data,
            errorPremiumEvalOption: state.PremiumEvalOption.errorPremiumEvalOption,
            loadingPremiumEvalOption: state.PremiumEvalOption.loadingPremiumEvalOption,
        });
    }), responsePremiumEvalOption = _d.responsePremiumEvalOption, errorPremiumEvalOption = _d.errorPremiumEvalOption, loadingPremiumEvalOption = _d.loadingPremiumEvalOption;
    useEffect(function () {
        if (trigger) {
            dispatch(premiumEvalOption({
                enable: enable,
                page: page,
                limit: limit,
                description: description,
            }));
        }
    }, [description, trigger]);
    return {
        responsePremiumEvalOption: responsePremiumEvalOption,
        errorPremiumEvalOption: errorPremiumEvalOption,
        loadingPremiumEvalOption: loadingPremiumEvalOption,
    };
};
